import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import TestErrors from "../../features/errors/TestError";
import App from "../layout/App";
import PrivacyPolicyPage from "../../features/home/PrivacyPolicyPage";
import TermsConditionsPage from "../../features/home/TermsConditionsPage";
import RefundCancellationPolicyPage from "../../features/home/RefundCancellationPolicyPage";
import ResponsiveOrderPage from "../../features/home/categories/ResponsiveOrderPage";
import AboutUsPage from "../../features/home/AboutUsPage";
import ContactUsPage from "../../features/home/ContactUsPage";
import ResponsiveHeaderPage from "../../features/home/Header/ResponsiveHeaderPage";
import ResponsiveFooterPage from "../../features/home/Footer/ResponsiveFooterPage";
import CategoryPage from "../../features/home/categories/CategoryPage";
import ProductDetailPage from "../../features/home/product/ProductDetailPage";
import CategoryProductGalleryComponent from "../../features/home/product/CategoryProductGalleryComponent";
import CartPage from "../../features/home/product/CartPage";
import ReceiptPage from "../../features/home/product/ReceiptPage";
import UserDashboard from "../../features/admin/UserDashboard";
import LoginPage from "../../features/home/Login/LoginPage";
import Wishlist from "../../features/admin/user/Wishlist";
import UserRegister from "../../features/home/Login/UserRegister";
import CategoryListComponent from "../../features/home/categories/CategoryListComponent";
import { AdminGuard } from "../common/guard/AdminGuard";
import AdminDashboard from "../../features/admin/AdminDashboard";

export const routes: RouteObject[] = [                          
            {path: 'not-found', element: <><ResponsiveHeaderPage /><NotFound /><ResponsiveFooterPage /></>},    
             {path: '*', element: <Navigate replace to='/not-found' />},
    {
        path:'/',
        element: <App />,
        children: [
        ]
    },
    {
        path:'/aboutus',
        element:<><ResponsiveHeaderPage /><AboutUsPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/contactus',
        element:<><ResponsiveHeaderPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/privacy',
        element:<><ResponsiveHeaderPage /><PrivacyPolicyPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/terms',
        element:<><ResponsiveHeaderPage /><TermsConditionsPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/refund',
        element:<><ResponsiveHeaderPage /><RefundCancellationPolicyPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/thankyou',
        element:<><ResponsiveHeaderPage /><ResponsiveOrderPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/catalog',
        element:<><ResponsiveHeaderPage /><CategoryListComponent /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/product/:id',
        // element:<><ResponsiveHeaderPage /><ResponsiveProductPage /><ContactUsPage /><ResponsiveFooterPage /></>
        element:<><ResponsiveHeaderPage /><ProductDetailPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/category/:id',
        element:<><ResponsiveHeaderPage /><CategoryPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/category/:id/products',
        element:<><ResponsiveHeaderPage /><CategoryProductGalleryComponent /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/cart',
        element:<><ResponsiveHeaderPage /><CartPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/receipt/:id',
        element:<><ResponsiveHeaderPage /><ReceiptPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/dashboard',
        element:<><ResponsiveHeaderPage /><UserDashboard /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/wishlist',
        element:<><ResponsiveHeaderPage /><Wishlist /><ResponsiveFooterPage /></>
    },
    {
        path:'/login',
        element:<><ResponsiveHeaderPage /><LoginPage /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
        path:'/register',
        element:<><ResponsiveHeaderPage /><UserRegister /><ContactUsPage /><ResponsiveFooterPage /></>
    },
    {
                element: <AdminGuard />, // Wrapper for staff-only access
                children: [
                    {
                        path: '/admin',
                        element: <><ResponsiveHeaderPage /><AdminDashboard /><ContactUsPage /><ResponsiveFooterPage /></>
                    },
                    // Add more admin sub-routes here if needed
                ]
            },

            // --- Fallbacks ---
            { path: 'not-found', element: <><ResponsiveHeaderPage /><NotFound /><ResponsiveFooterPage /></> },
            { path: '*', element: <Navigate replace to='/not-found' /> },
]

export const router = createBrowserRouter(routes);